import { v7 as uuidv7 } from 'uuid'

/**
 * UUIDv7 minden API-request-hez (DEC-FE-010). A backend `AssignRequestId`
 * middleware elfogadja a kliens által küldött jól formált ID-t és
 * visszaküldi a response `X-Request-ID` headerben.
 */
export function generateRequestId(): string {
  return uuidv7()
}
